// Resolve a stored file reference into something a browser can actually open.
//
// New uploads are absolute S3 URLs, but older rows hold a backend-relative
// path like "/uploads/proofs/x.jpg". Dropped straight into an href those
// resolve against the *frontend* origin, which serves the SPA — and since
// there's no catch-all route, the user just gets a blank page. Prefixing the
// API base points them at the backend's /uploads static mount instead.

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export function resolveFileUrl(path?: string | null): string {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  return `${API_BASE_URL}${path.startsWith('/') ? '' : '/'}${path}`;
}
